import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_LOCALE, SUPPORTED_LOCALE_CODES } from './constants';
import en from './bundles/en';
const loaders = {
    de: () => import(/* webpackChunkName: "lang-de" */ './bundles/de'),
    fr: () => import(/* webpackChunkName: "lang-fr" */ './bundles/fr'),
    es: () => import(/* webpackChunkName: "lang-es" */ './bundles/es'),
    it: () => import(/* webpackChunkName: "lang-it" */ './bundles/it'),
    pt: () => import(/* webpackChunkName: "lang-pt" */ './bundles/pt'),
    nl: () => import(/* webpackChunkName: "lang-nl" */ './bundles/nl'),
    pl: () => import(/* webpackChunkName: "lang-pl" */ './bundles/pl'),
    cs: () => import(/* webpackChunkName: "lang-cs" */ './bundles/cs'),
    ja: () => import(/* webpackChunkName: "lang-ja" */ './bundles/ja'),
    ko: () => import(/* webpackChunkName: "lang-ko" */ './bundles/ko'),
    zh: () => import(/* webpackChunkName: "lang-zh" */ './bundles/zh'),
    ru: () => import(/* webpackChunkName: "lang-ru" */ './bundles/ru'),
    uk: () => import(/* webpackChunkName: "lang-uk" */ './bundles/uk'),
    no: () => import(/* webpackChunkName: "lang-no" */ './bundles/no'),
    sv: () => import(/* webpackChunkName: "lang-sv" */ './bundles/sv'),
};
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources: { en: { translation: en } },
    partialBundledLanguages: true,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALE_CODES],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
        bindI18n: 'languageChanged loaded',
        bindI18nStore: 'added',
    },
});
const pending = {};
/** Lädt das Sprachpaket einmalig nach. */
export function ensureLanguage(lng) {
    const code = (lng || DEFAULT_LOCALE).split(/[-_]/)[0].toLowerCase();
    const loader = loaders[code];
    if (!loader || i18n.hasResourceBundle(code, 'translation'))
        return Promise.resolve();
    if (!pending[code]) {
        pending[code] = loader()
            .then((mod) => {
            i18n.addResourceBundle(code, 'translation', mod.default, true, true);
        })
            .catch(() => {
            delete pending[code];
        });
    }
    return pending[code];
}
// Bei jedem Sprachwechsel das passende Paket nachladen
i18n.on('languageChanged', (lng) => {
    ensureLanguage(lng);
});
export const i18nReady = ensureLanguage(i18n.language);
export default i18n;
